import React , {useContext} from "react";
import app from "./base";
import CallFurioos from "./FurioosController";
import {Component} from "react";
import ReactDOM from 'react-dom';
import AgoraRTC from "agora-rtc-sdk";
import { withRouter, Redirect } from "react-router";
import { AuthContext } from "./Auth.js";
import * as firebase from 'firebase';
import PrivateAppointmentCreator from './PrivateAppointmentCreator';
import backBanner from "./backBanner.jpg"
import backgroundCentre from "./backgroundCentre.jpg"
import logoParkvillegreens from "./logoParkvillegreens.png"
import personPlaceHolder from './personPlaceHolder.jpg';
import icon_camera from './icon_camera-01.svg'
import loadingGif from './loadingGif.gif';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import App from './App';
const fetch = require('node-fetch');

const USER_ID = Math.floor(Math.random() * 1000000001);
let client = AgoraRTC.createClient({ mode: "live", codec: "h264" });
const project_code = "parkville_greens_erin_gates";
var userEmail;
var userType;
var userFullName;
var userPhoneNumber;
var userAvatarCode;
var userAppointmentTimeUnix;
var userAppointmentTime;
var userAppointmentCode;
var isMakingAvatar = false;
var thisFileSelector;
var imageReadResults;
var userAssignedTo;

var usingUploadedImage = false;
var usingTakenImage = false;
var generatedImage = false;

class Home extends Component{

  
  localStream;

  componentDidMount(){
  
    window.addEventListener("offline", function(e) {
      showPopForOfflineConnection();
    });

    const showPopForOfflineConnection = () =>{
      window.alert("Lost internet connection, please turn back on.");
    }

    const handleJoinMeeting = () =>{


      let currentTimeDate = Date.now();
      //this should users to join meetings that started 30min ago;
      var timeIn5Min = currentTimeDate + 300000;//300000
      var time30MinAgo = currentTimeDate - 1800000;
      //console.log("user avatar code " + userAvatarCode);
      if(userAvatarCode === "undefined" && userAppointmentCode !== "undefined" && timeIn5Min >= userAppointmentTimeUnix){
        //if avatar code is undefined call create avatar
        this.CreateAvatar();
        //all our variables should be fine here so lets make this in a functions at bottom 

      }
      else if(userAppointmentCode !== "undefined" && timeIn5Min >= userAppointmentTimeUnix){//&& timeIn5Min >= userAppointmentTimeUnix
        //(user_email, user_name, user_phone, user_avatar, user_time, img_file)
        var currentUser = app.auth().currentUser;
        var thisUid = currentUser.uid;
        CallFurioos(userEmail, userFullName, userPhoneNumber, userAvatarCode, userAppointmentTimeUnix, " ", userType, userAppointmentCode, thisUid, () => {this.FinishFurioos();});//then on user active then we pass informatioin
        
        var createNewLoading = document.createElement("div");
        createNewLoading.className = "overlayLoading";
        createNewLoading.id = "loadingScreen";
        var loadingGifImg = document.createElement("img");
        loadingGifImg.className = "loadingGif";
        loadingGifImg.id = "loadingGifImg";
        loadingGifImg.src = loadingGif;
        var rootElement = document.getElementById("root");
        rootElement.appendChild(createNewLoading);
        createNewLoading.appendChild(loadingGifImg);
        
        //join agora voice channel here also
        var el = document.getElementById("meetingButton");
        el.remove();
        
        var parkLogo = document.getElementById("parkLogo")
        parkLogo.remove();

        var signoutButton = document.getElementById("signoutButton")
        signoutButton.remove();

        if(userType === "admin"){
          var removeButton1 = document.getElementById("startAppointmentButton")
          removeButton1.remove();
    
          var removeButton2 = document.getElementById("createAppointmentButton");
          removeButton2.remove();
        }

        var furPlay = document.getElementById("callPlayer");
        furPlay.className = "overlay";
        //window.startChatByRoomID("testID");
        var idToUse = app.auth().currentUser.uid + "_" + USER_ID;

        this.joinChannel(userAppointmentCode, idToUse);

        if(userType === "admin"){
          app.database().ref('/client_appointments/' + project_code).child(userAppointmentCode).once('value', snapshot => {

            var hasMeetingStarted = snapshot.val().started;
            console.log(userAppointmentCode + " HAS MEETING STARTED " + hasMeetingStarted);
            if(hasMeetingStarted === false){
              var StartRef = app.database().ref('/client_appointments/' + project_code + "/" + userAppointmentCode).child("started");
              StartRef.set(true);
              UseAnotherAppointmentHome();
            }

          });
        }


      } else {
        if(userAppointmentCode === "undefined")
        {
          window.alert("No meetings registered to your account.");
        }
        else if (timeIn5Min <= userAppointmentTimeUnix)
        {
          window.alert("Appointment not ready, the earliest you can join is 5 minutes before.");
        }
      }
    }


    // this.initLocalStream();
    // this.initClient();

    var thisButton = document.getElementById("meetingButton");

    thisButton.onclick = () => {handleJoinMeeting();};

    var UseAnotherAppointmentHome = () =>{

      var d = new Date();
      var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      var thisMonth = months[d.getMonth()];
      var thisYear = d.getFullYear();
      var yearString = thisYear.toString();
  
      app.database().ref('/kavtek_clients/' + project_code).once('value', snapshot => {
  
        if(snapshot.hasChild(yearString + thisMonth)){
          var totalAppUsed = snapshot.child(yearString + thisMonth).val();
  
          var totalAppsUsedRef = app.database().ref('/kavtek_clients/' + project_code + '/' + yearString + thisMonth);
  
          var newTotal = totalAppUsed + 1;
  
          totalAppsUsedRef.set(newTotal);
  
        }else{
          var totalAppsUsedRef = app.database().ref('/kavtek_clients/' + project_code + '/' + yearString + thisMonth);
          var totalAppUsed = 1;
          totalAppsUsedRef.set(totalAppUsed);
        }
  
      });
  
    }
//firebase database stuff for the home page will be done here
    //if appointment code is not given to us
    const getAppointmentCode = () =>{
     // console.log("this users email " + userEmail);
      app.database().ref('/client_emails/' + project_code ).orderByChild('email').equalTo(userEmail).once('value', snapshot => {
      
        var entry = "0";//might need to fix this to get first item of list?

        //this will be all we need to do to allow users to make multiple appointments
        //need to cycle through each child find the nearest appointment
        var closestKey;
        var currentDifference = 1000000000000;
        let currentTimeDate = Date.now();
        //this should users to join meetings that started 30min ago;
        var time30MinAgo = currentTimeDate - 1800000;

        snapshot.forEach(element => {
          
          var elementTime = element.val().timeOfAppointment;
          
          if(elementTime > time30MinAgo && (elementTime - time30MinAgo) < currentDifference){
            currentDifference = (elementTime - time30MinAgo);
            closestKey = element.val().appointmentID;
            //console.log("TEST KEY " + closestKey);
          }
        });


        //var snapVal = snapshot.child("appointmentID").val();
        var appCode = closestKey;
        userAppointmentCode = appCode;
        var appElement = document.getElementById("yourAppointmentTime");
        appElement.innerHTML = userAppointmentCode;

        getAppointmentTime();
      });

    }
  
    //if appointment code is given to us
    const setAppointmentCode = () =>{
      var currentHref = window.location.href;
      var splitter = currentHref.split("?");
      var toRedirect = "/";

      //console.log("split length " + splitter.length);
      if(splitter.length > 1){

        //console.log("splitter is greater than 1");
        var splitIt = splitter[1].split("=");
        var splitAgain = splitIt[1].split("_split_");
        //splitter one is the user appointment code

        userAppointmentCode = splitAgain[0];

        getAppointmentTime();
      }
      else{
        //console.log("splitter is less than 1");
        getAppointmentCode();
      }
    }


    const getAppointmentTime = () =>{

      console.log("User appointment code = " + userAppointmentCode)
      if(userAppointmentCode == null){
        var appElement = document.getElementById("yourAppointmentTime");
        appElement.innerHTML = "No upcoming appointments";
        userAppointmentCode = "undefined"
      }
      else{
        app.database().ref('/client_appointments/' + project_code).child(userAppointmentCode).once('value', snapshot => {
          //timeOfAppointment
          //check users
          //if user
          var allUsers = snapshot.child("users");
          userAssignedTo = snapshot.val().assignedTo;
          var isUserInMeeting = false;
          allUsers.forEach(element => {
            //console.log("ALL USERS  " + element.val().email + " user email " + userEmail);
            if(userEmail == element.val().email){
              isUserInMeeting = true;
            }
          });
          

          if(isUserInMeeting || userType === "admin"){

            userAppointmentTimeUnix = snapshot.val().timeOfAppointment;
            var dateObj = new Date(userAppointmentTimeUnix );

            let currentTimeDate = Date.now();
            //this should users to join meetings that started 30min ago;
            var time30MinAgo = currentTimeDate - 1800000;

            if(time30MinAgo < dateObj)
            {
              var appElement = document.getElementById("yourAppointmentTime");
              appElement.innerHTML = dateObj;

              var usersHost = document.getElementById("yourHost");
          
              userAssignedTo = userAssignedTo.replace("_", " ");
              usersHost.innerHTML = userAssignedTo;
            }
            else
            {
              var appElement = document.getElementById("yourAppointmentTime");
              appElement.innerHTML = "No upcoming appointments";
              userAppointmentCode = "undefined"
  
              var usersHost = document.getElementById("yourHost");
          
              usersHost.innerHTML = "No upcoming appointments";
            }
          }
          else{
            //No upcoming appointments
            var appElement = document.getElementById("yourAppointmentTime");
            appElement.innerHTML = "No upcoming appointments";
            userAppointmentCode = "undefined"

            var usersHost = document.getElementById("yourHost");
        
            usersHost.innerHTML = "No upcoming appointments";
          }

        });
      }
 

    }

    const usersRef = app.database().ref().child('users');

    var currentUser = app.auth().currentUser;

    if(currentUser){

      var userId = currentUser.uid;

      var thisUserRef = usersRef.child(userId);


      this.localStream = AgoraRTC.createStream({
        streamID: userId+ "_" + USER_ID,
        audio: true,
        video: false,
        screen: false
      });

      this.initLocalStream();
      this.initClient();
      // var userEmail;
      // var userFirstName;
      // var userLastName;
      // var userProjectCode = this.project_code;


      thisUserRef.once('value', snap => {

        userEmail = snap.val().email;
        userFullName = snap.val().fullName;
        userPhoneNumber = snap.val().phoneNumber;
        userAvatarCode = snap.val().avatarCode;
        userType = snap.val().userType;

        if(userType === "admin"){
          this.AddAdminFeatures();
        }
        //console.log("WE HAVE A USER TYPE " + userType);
        // if(snap.val().userType.exists === true){
        //   userType = snap.val().userType;
        //   console.log("WE HAVE A USER TYPE " + userType);
        // }
        // else{
        //   userType = "undefined";
        //   console.log("WE DONT HAVE A USER TYPE " + userType);
        // }

        var emailElement = document.getElementById("yourEmail");
        var phoneNumberElement = document.getElementById("yourPhoneNumber")
        var userNameElement = document.getElementById("yourName");

        emailElement.innerHTML = userEmail;
        phoneNumberElement.innerHTML = userPhoneNumber;

        if(userFullName !== "undefined"){
          userNameElement.innerHTML = userFullName;
        } else {
          userNameElement.innerHTML = "Guest User";
        }
        //console.log("WE GOT EMAIL FROM USER DATABASE: " + userEmail);
        setAppointmentCode();
      });



    }

    


  }

  initLocalStream = () => {
    let me = this;
    me.localStream.init(
      function() {
        console.log("getUserMedia successfully");
        me.localStream.play("agora_cam");
      },
      function(err) {
        console.log("getUserMedia failed", err);
      }
    );
  };

  initClient = () => {
    client.init(
      "b4b5680dc72045d9b309088922b49cf4",
      function() {
        console.log("AgoraRTC client initialized");
      },
      function(err) {
        console.log("AgoraRTC client init failed", err);
      }
    );
    this.subscribeToClient();
  };

  subscribeToClient = () => {
    let me = this;
    client.on("stream-added", me.onStreamAdded);
    client.on("stream-subscribed", me.onRemoteClientAdded);

    client.on("stream-removed", me.onStreamRemoved);

    client.on("peer-leave", me.onPeerLeave);
  };

  state = {
    remoteStreams: {}
    // error: null,
    // isLoaded: false,
    // items: [],
  }

  onStreamAdded = evt => {
    let me = this;
    let stream = evt.stream;
    console.log("New stream added: " + stream.getId());
    let { remoteStreams } = me.state;
    //for testingh
    // for (let value of Object.keys(remoteStreams)) {
    //   totalStreams[value] = this.state.remoteStreams[value];
    // }
    // totalStreams[stream.getId()] = stream;

    // for (let value of Object.keys(totalStreams)) {
    //   console.log("GOING THROUGH ALL TOTAL STREAMS " + value);
    // }

    me.setState(
      {
        remoteStreams: {
          ...this.state.remoteStreams,
          [stream.getId()]: stream
        }
      },
      () => {
        // Subscribe after new remoteStreams state set to make sure
        // new stream dom el has been rendered for agora.io sdk to pick up
        // for (let value of Object.keys(this.state.remoteStreams)) {
        //   console.log("CALLBACK STREAMS " + value);
        // }

        client.subscribe(stream, function(err) {
          console.log("Subscribe stream failed", err);
        });
      }
    );
  };

  joinChannel = (channelName, thisUserId) => {
    let me = this;
    client.join(
      null,
      channelName,
      thisUserId,
      function(uid) {
        console.log("User " + uid + " join channel successfully");
        client.publish(me.localStream, function(err) {
          console.log("Publish local stream error: " + err);
        });

        client.on("stream-published", function(evt) {
          console.log("Publish local stream successfully");
        });
      },
      function(err) {
        console.log("Join channel failed", err);
      }
    );
  };

  onRemoteClientAdded = evt => {
    let me = this;
    let remoteStream = evt.stream;
    me.state.remoteStreams[remoteStream.getId()].play(
      "agora_remote " + remoteStream.getId()
    );
  };

  onStreamRemoved = evt => {
    let me = this;
    let stream = evt.stream;
    if (stream) {
      let streamId = stream.getId();
      let { remoteStreams } = me.state;

      stream.stop();

      // // loop over values
      // for (let value of Object.values(remoteStreams)) {
      //   console.log("All remote stream keys " + value); // John, then 30
      // }


      delete remoteStreams[streamId];

      me.setState({ remoteStreams });

      console.log("Remote stream is removed " + stream.getId());
    }
  };

  onPeerLeave = evt => {
    let me = this;
    let stream = evt.stream;
    if (stream) {
      let streamId = stream.getId();
      let { remoteStreams } = me.state;

      stream.stop();

      //       // loop over values
      // for (let value of Object.keys(remoteStreams)) {
      //   console.log("All remote stream keys " + value); // John, then 30
      // }

      delete remoteStreams[streamId];


      // for (let value of Object.keys(remoteStreams)) {
      //   console.log("All remote stream keys " + value); // John, then 30
      // }

      me.setState({ remoteStreams });

      console.log("Remote stream is removed " + stream.getId());
    }
  };


  handleJoinMeetingAvatarDone = () =>{

    console.log("user avatar code " + userAvatarCode);
    if(userAvatarCode === "undefined" && userAppointmentCode !== "undefined"){
      //if avatar code is undefined call create avatar
      this.CreateAvatar();
      //all our variables should be fine here so lets make this in a functions at bottom 

    }
    else if(userAppointmentCode !== "undefined"){

      var currentUser = app.auth().currentUser;
      var thisUid = currentUser.uid;
      CallFurioos(userEmail, userFullName, userPhoneNumber, userAvatarCode, userAppointmentTimeUnix, " ", userType, userAppointmentCode, thisUid, () => {this.FinishFurioos();});//then on user active then we pass informatioin
      //then on user active then we pass informatioin

      var createNewLoading = document.createElement("div");
      createNewLoading.className = "overlayLoading";
      createNewLoading.id = "loadingScreen";
      var loadingGifImg = document.createElement("img");
      loadingGifImg.className = "loadingGif";
      loadingGifImg.id = "loadingGifImg";
      loadingGifImg.src = loadingGif;
      var rootElement = document.getElementById("root");
      rootElement.appendChild(createNewLoading);
      createNewLoading.appendChild(loadingGifImg);

      //join agora voice channel here also
      var el = document.getElementById("meetingButton");
      el.remove();

      if(userType === "admin"){
        var removeButton1 = document.getElementById("startAppointmentButton")
        removeButton1.remove();
  
        var removeButton2 = document.getElementById("createAppointmentButton");
        removeButton2.remove();
      }
      
      var furPlay = document.getElementById("callPlayer");
      furPlay.className = "overlay";
      //window.startChatByRoomID("testID");
      var idToUse = app.auth().currentUser.uid + "_" + USER_ID;

      this.joinChannel(userAppointmentCode, idToUse);
    }
  }
  //avatar sdk function here
  CreateAvatar = () =>{
    generatedImage = true;
    //HERE LETS CREATE THE UI HTML FOR THIS
    //PARTS OF UI
    //CREATE YOUR OWN AVATAR(TITLE TEXT)
    //click camera below to take a selfie and create your avatar (subtext)
    //picture in centre
    //picture button
    //upload a photo button

    //icon_camera
    var parkLogo = document.getElementById("parkLogo")
    parkLogo.remove();

    var avatarSKUI = (
      <>
        <div>
          <button className="signOutButton" onClick={() => app.auth().signOut()}>Sign out</button>
        </div>
        <div style ={ { backgroundImage: "url("+backgroundCentre+")" }} className="overlayFullScreen" id="avtarContainer">
          <div className="overlayFullScreen3">
            <h2 className="blackBoxTitle">CREATE YOUR OWN AVATAR</h2>
            <h3 id="selfieText" className="blackBoxTitle">Click the camera button below to take a selfie and create your avatar</h3>
            <h3 id="errorMessage" className="blackBoxTitle"> </h3>
          </div>
          <div className="overlayFullScreen2">
            {/* <video id="videoSelf" width="0" height="0"></video> */}
            <div id="videoHolder" className="videoHolder">
              <div className="uploadedPhotoHolder" id="uploadedPhotoHolder">
                <img id="selfiePlaceholder" className="uploadedPhoto" src={personPlaceHolder} alt="placeholder"></img>
              </div>
              <Camera
                onTakePhoto = { (dataUri) => { this.handleTakePhoto(dataUri); } }
                onTakePhotoAnimationDone = { (dataUri) => { this.handleTakePhotoAnimationDone(dataUri); } }
                onCameraError = { (error) => { this.handleCameraError(error); } }
                idealFacingMode = {FACING_MODES.ENVIRONMENT}
                idealResolution = {{width: 640, height: 480}}
                imageType = {IMAGE_TYPES.JPG}
                imageCompression = {0.97}
                isMaxResolution = {true}
                isImageMirror = {false}
                isSilentMode = {false}
                isDisplayStartCameraError = {true}
                isFullscreen = {false}
                sizeFactor = {1}
                onCameraStart = { (stream) => { this.handleCameraStart(stream); } }
                onCameraStop = { () => { this.handleCameraStop(); } }
              />
            </div>
            {/* <br></br>
            <button className="uploadedSelfie" id="uploadASelfie" >
              <img id="takeSelfieChild" className="iconCam" src={icon_camera} alt="icon_camera"></img>
            </button> */}
          </div>

          <button className="uploadPhotoButton" id="uploadAPhoto" onClick={this.SelectAPhoto}>UPLOAD A PHOTO</button>
          {/* <div id="callPlayer"></div>
          {Object.keys(this.state.remoteStreams).map(key => {
            let stream = this.state.remoteStreams[key];
            let streamId = stream.getId();
            // for (let value of Object.keys(this.state.remoteStreams)) {
            //   console.log("GOING THROUGH ALL REMOTE STREAM KEYS " + value);
            // }
            return (
              <div
                key={streamId}
                id={`agora_remote ${streamId}`}
                style={{ width: "0px", height: "0px" }}
              />
            );
          })} */}
        </div>
      </>
    );

    ReactDOM.render(avatarSKUI, document.getElementById('rootCam'));
    //var rootObj = document.getElementById('root');
    //rootObj.appendChild(avatarSKUI);

    this.CameraController();

    var innerCircle = document.getElementById("inner-circle");

    //<img id="takeSelfieChild" className="iconCam" src={icon_camera} alt="icon_camera"></img>
    var imageCam = document.createElement("img");
    imageCam.src = icon_camera;
    imageCam.id = "takeSelfieChild";
    imageCam.className = "iconCam";
    innerCircle.appendChild(imageCam);
    //need to get the ui first and image
    // const videoConstraints = {
    //   facingMode: "user"
    // };
    
    // var infoContainer = document.getElementById("infoContainer");

    // var cam = document.createElement("Webcam");
    // cam.videoConstraints = videoConstraints;

    // infoContainer.appendChild(cam);
    //return <Webcam videoConstraints={videoConstraints} />;

  }


  CameraController = () => {
    console.log("Camera Controller home");
    
    navigator.getUserMedia = navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia;

    var thereWasAnError = false;
    
    if (navigator.getUserMedia) {

        //selfiePlaceholder
      navigator.mediaDevices.getUserMedia({ audio: false, video: { width: 400, height: 300 } }).then(
        (stream) => {
          console.log("user has cam")
          //var selfPlace = document.getElementById("selfiePlaceholder");
          //selfPlace.remove();
      }).catch( function(err) {
            console.log("The following error occurred: " + err.name);
            if(err.name === "NotFoundError"){

              var tempElementChild = document.getElementById("takeSelfieChild");
              tempElementChild.remove();

              var tempElement = document.getElementById("uploadASelfie");
              tempElement.remove();

              var tempElementText = document.getElementById("selfieText");
              tempElementText.remove();

              thereWasAnError = true;
                //promt user does not have camera please enter picture
            }
      });
    } else {
        console.log("getUserMedia not supported");
    }

    this.thisFileSelector = this.buildFileSelector();

    var buttonUploadPhoto = document.getElementById("uploadAPhoto");

    
  }

  handleTakePhoto = (dataUri) =>{
    // Do stuff with the photo...
    console.log('takePhoto');
  }
 
  handleTakePhotoAnimationDone = (dataUri) => {
    // Do stuff with the photo...
    //need to do some shit here

    console.log("TAKEN PHOTO");

    var imageHolder = document.getElementById("uploadedPhotoHolder");
    imageHolder.style.zIndex =4;
    var selfieHolder = document.getElementById("selfiePlaceholder");
    selfieHolder.style.zIndex =5;
    
    
    // FileReader support
    
      // Resize the image
    var image = new Image();
    image.onload = function () {
      console.log("Image is resizing");
      var canvas = document.createElement('canvas'),
      max_size = 620,// TODO : pull max size from a site config
      width = image.width,
      height = image.height;
        if (width > height) {
            if (width > max_size) {
                height *= max_size / width;
                width = max_size;
            }
        } else {
            if (height > max_size) {
                width *= max_size / height;
                height = max_size;
            }
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        var dataUrl = canvas.toDataURL('image/jpeg');
        var resizedImage = dataUrl;
        imageReadResults = dataUrl;
        selfieHolder.src = imageReadResults;
        console.log(resizedImage);
        console.log("Image is resized");
    }
    
    //selfieHolder.src = fr.result;
    //imageReadResults = fr.result;
    image.src = dataUri;
    console.log("IMAGE READ RESULTS " + imageReadResults + " END");

    

        //now we need to make that bottom button only 50% of the screen and add a new button to id=avtarContainer
    //uploadAPhoto

    //need to add a button between upload photo and generate avatar

    var uploadAPhotoButton = document.getElementById("uploadAPhoto");
    uploadAPhotoButton.className = "uploadPhotoButtonOneThird";

    var avatarContainer = document.getElementById("avtarContainer");

    var generateAvatarButton = document.createElement("button");
    generateAvatarButton.id = "generateAvatarButton";
    generateAvatarButton.className = "generateAvatarOneThird";
    generateAvatarButton.innerHTML = "GENERATE AVATAR";

    avatarContainer.append(generateAvatarButton);

    generateAvatarButton.onclick = this.GenerateAvatar;

    var retakePhotoButton = document.createElement("button");
    retakePhotoButton.id = "retakePhotoButton";
    retakePhotoButton.className = "retakeAvatarOneThird";
    retakePhotoButton.innerHTML = "RETAKE PHOTO";

    avatarContainer.append(retakePhotoButton);

    retakePhotoButton.onclick = this.retakePhotoClick;
  }

  retakePhotoClick = () =>{
    var removeGen = document.getElementById("generateAvatarButton");
    removeGen.remove();

    var retakePhotoButton = document.getElementById("retakePhotoButton");
    retakePhotoButton.remove();
    
    var uploadAPhotoButton = document.getElementById("uploadAPhoto");
    uploadAPhotoButton.className = "uploadPhotoButton";

    var imageHolder = document.getElementById("uploadedPhotoHolder");
    imageHolder.style.zIndex =0;
    var selfieHolder = document.getElementById("selfiePlaceholder");
    selfieHolder.style.zIndex =0;
  } 
 
  handleCameraError = (error) =>{
    console.log('handleCameraError', error);
  }
 
  handleCameraStart = (stream) => {
    console.log('handleCameraStart');
  }
 
  handleCameraStop = () =>{
    console.log('handleCameraStop');
  }

  buildFileSelector= () =>{
    console.log("file selector build");
    const fileSelector = document.createElement('input');
    fileSelector.setAttribute('type', 'file');
    fileSelector.setAttribute('multiple', 'multiple');
    return fileSelector;
  }

  SelectAPhoto =  (e) => {
    console.log("select a photo");
    e.preventDefault();
    this.thisFileSelector.onchange = this.SelectedPhoto;
    this.thisFileSelector.click();
  }

  SelectedPhoto = (e) =>{
    //move our zindex of the photo up
  
    console.log("SELECTED PHOTO");

    var imageHolder = document.getElementById("uploadedPhotoHolder");
    imageHolder.style.zIndex =4;
    var selfieHolder = document.getElementById("selfiePlaceholder");
    selfieHolder.style.zIndex =5;
    console.log(this.thisFileSelector.files[0].name);

    var errorHolder = document.getElementById("errorMessage");
    
    if(this.thisFileSelector.files[0].name.includes(".png") || this.thisFileSelector.files[0].name.includes(".jpg") 
    || this.thisFileSelector.files[0].name.includes(".jpeg")|| this.thisFileSelector.files[0].name.includes(".bmp")){
      
      var files = this.thisFileSelector.files
      // FileReader support
      if (FileReader && files && files.length) {
          var fr = new FileReader();
          fr.onload = function () {

              // Resize the image
            var image = new Image();
            image.onload = function () {
              console.log("Image is resizing");
              var canvas = document.createElement('canvas'),
              max_size = 620,// TODO : pull max size from a site config
              width = image.width,
              height = image.height;
                if (width > height) {
                    if (width > max_size) {
                        height *= max_size / width;
                        width = max_size;
                    }
                } else {
                    if (height > max_size) {
                        width *= max_size / height;
                        height = max_size;
                    }
                }
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                var dataUrl = canvas.toDataURL('image/jpeg');
                var resizedImage = dataUrl;
                imageReadResults = dataUrl;
                console.log(resizedImage);
                console.log("Image is resized");
            }
            


            selfieHolder.src = fr.result;
            imageReadResults = fr.result;
            image.src = fr.result;
            console.log("IMAGE READ RESULTS " + imageReadResults + " END");
          }
          fr.readAsDataURL(files[0]);
  
      }
      //now we need to make that bottom button only 50% of the screen and add a new button to id=avtarContainer
      //uploadAPhoto
      var uploadAPhotoButton = document.getElementById("uploadAPhoto");
      uploadAPhotoButton.className = "uploadPhotoButtonHalfLeft";

      var avatarContainer = document.getElementById("avtarContainer");

      var generateAvatarButton = document.createElement("button");
      generateAvatarButton.id = "generateAvatarButton";
      generateAvatarButton.className = "generateAvatarRight";
      generateAvatarButton.innerHTML = "GENERATE AVATAR";

      avatarContainer.append(generateAvatarButton);

      generateAvatarButton.onclick = this.GenerateAvatar;
    }
    else{
      errorHolder.innerHTML = "Please use an image of format .jpg, .png, .bmp";
    }

    //selfieHolder.src = this.thisFileSelector.files[0];
  }

  GenerateAvatar = () =>{
    // HERE WE CALL OUR WEB FUNCTIONS TO GET AUTHORIZATION STUFF THEN WE CAN PUSH FROM HERE LATER


    console.log("Start Generate Avatar");

    var currentUser = app.auth().currentUser;
    var thisUid = currentUser.uid;
    var avatarName =  currentUser.uid;
    var files = this.thisFileSelector.files
    

    CallFurioos(userEmail, userFullName, userPhoneNumber, userAvatarCode, userAppointmentTimeUnix, imageReadResults, userType, userAppointmentCode, thisUid, () => {this.FinishFurioos();});//then on user active then we pass informatioin
  
    //then on user active then we pass informatioin
    //join agora voice channel here also
    //var el = document.getElementById("meetingButton");
    //el.remove();
    //loading screen
    var createNewLoading = document.createElement("div");
    createNewLoading.className = "overlayLoading";
    createNewLoading.id = "loadingScreen";
    var loadingGifImg = document.createElement("img");
    loadingGifImg.className = "loadingGif";
    loadingGifImg.id = "loadingGifImg";
    loadingGifImg.src = loadingGif;
    var rootElement = document.getElementById("root");
    rootElement.appendChild(createNewLoading);
    createNewLoading.appendChild(loadingGifImg);

    var generateAvatarButtonTemp = document.getElementById("generateAvatarButton");
    generateAvatarButtonTemp.remove();

    if(userType === "admin"){
      var removeButton1 = document.getElementById("startAppointmentButton")
      removeButton1.remove();

      var removeButton2 = document.getElementById("createAppointmentButton");
      removeButton2.remove();
    }

    var furPlay = document.getElementById("callPlayer");
    furPlay.className = "overlay";
    //window.startChatByRoomID("testID");
    var idToUse = app.auth().currentUser.uid + "_" + USER_ID;

    
    //Camera.onCameraStop();
    var videoHolderStop = document.getElementById("videoHolder");

    videoHolderStop.querySelectorAll('*').forEach(n => n.remove());

    videoHolderStop.remove();

    var idToUse = app.auth().currentUser.uid + "_" + USER_ID;

    this.joinChannel(userAppointmentCode, idToUse);
    console.log("SHOULD BE IN A CHANNEL")
    if(userType === "admin"){
      app.database().ref('/client_appointments/' + project_code).child(userAppointmentCode).once('value', snapshot => {

        var hasMeetingStarted = snapshot.val().started;
        console.log(userAppointmentCode + " HAS MEETING STARTED " + hasMeetingStarted);
        if(hasMeetingStarted === false){
          var StartRef = app.database().ref('/client_appointments/' + project_code + "/" + userAppointmentCode).child("started");
          StartRef.set(true);
          this.UseAnotherAppointmentNotInComponent();
        }

      });
    }
  }


  UseAnotherAppointmentNotInComponent = () =>{

    var d = new Date();
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var thisMonth = months[d.getMonth()];
    var thisYear = d.getFullYear();
    var yearString = thisYear.toString();

    app.database().ref('/kavtek_clients/' + project_code).once('value', snapshot => {

      if(snapshot.hasChild(yearString + thisMonth)){
        var totalAppUsed = snapshot.child(yearString + thisMonth).val();

        var totalAppsUsedRef = app.database().ref('/kavtek_clients/' + project_code + '/' + yearString + thisMonth);

        var newTotal = totalAppUsed + 1;

        totalAppsUsedRef.set(newTotal);

      }else{
        var totalAppsUsedRef = app.database().ref('/kavtek_clients/' + project_code + '/' + yearString + thisMonth);
        var totalAppUsed = 1;
        totalAppsUsedRef.set(totalAppUsed);
      }

    });

  }

  FinishFurioos = () =>{

    var newHtml = ( 
      <>          
        <div>
          <img className="BackBanner" src={backBanner} alt="Banner" />;
          <img id="parkLogo" className="parkLogo" src={logoParkvillegreens} alt="Logo" />;
          <button id="signoutButton" className="signOutButton" onClick={() => app.auth().signOut()}>Sign out</button>
        </div>
        
        <div className="BlackFrontOverlay" id="infoContainer">
          <h2 className="blackBoxTitle">Thanks For Coming!</h2>
          
          <button className="joinMeetingButton" id="newMeeting" >Re-join Meeting</button>
        </div>
      </>
    );

    
    ReactDOM.render(newHtml, document.getElementById('root'));


    
    var reJoinButton = document.getElementById("newMeeting");

    reJoinButton.onclick = () =>{
      console.log("rejoin click");
      
      ReactDOM.render( < App / > , document.getElementById('root'));
    };

  }

  AddAdminFeatures = () =>{

    console.log("This user is an admin add in admin settings");
    
    var blackBoxInfoContainer = document.getElementById("infoContainer");
    var createAppointmentButton = document.createElement("button");
    createAppointmentButton.className = "createMeetingButton";
    createAppointmentButton.id = "createAppointmentButton";

    createAppointmentButton.innerHTML = "Create Meeting";

    
    var startAppointmentButton = document.createElement("button");
    startAppointmentButton.className = "startMeetingButton";
    startAppointmentButton.id = "startAppointmentButton";

    startAppointmentButton.innerHTML = "Start Meeting";


    createAppointmentButton.onclick = () =>{ 
      var PrivateAppCreate = PrivateAppointmentCreator(userEmail, userFullName);
    };

    startAppointmentButton.onclick = () =>{
      this.JoinMeetingNoRestrictions();
    }

    blackBoxInfoContainer.append(startAppointmentButton);
    blackBoxInfoContainer.append(createAppointmentButton);
  }

  JoinMeetingNoRestrictions = () =>{
    //(user_email, user_name, user_phone, user_avatar, user_time, img_file)
    var currentUser = app.auth().currentUser;
    var thisUid = currentUser.uid;

    var currentDate = new Date();
    var currentUnix = currentDate.getTime();

    var randomMeetingCode = Math.floor(Math.random() * 1000000001);


    if(userAvatarCode === "undefined"){
      CallFurioos(userEmail, userFullName, userPhoneNumber, "e5fe5968-058c-494b-8e8f-ca95425a2a02", currentUnix, " ", userType, randomMeetingCode, thisUid, () => {this.FinishFurioos();});//then on user active then we pass informatioin
    }
    else{
      CallFurioos(userEmail, userFullName, userPhoneNumber, userAvatarCode, currentUnix, " ", userType, randomMeetingCode, thisUid, () => {this.FinishFurioos();});//then on user active then we pass informatioin
    }

    
    
    var createNewLoading = document.createElement("div");
    createNewLoading.className = "overlayLoading";
    createNewLoading.id = "loadingScreen";
    var loadingGifImg = document.createElement("img");
    loadingGifImg.className = "loadingGif";
    loadingGifImg.id = "loadingGifImg";
    loadingGifImg.src = loadingGif;
    var rootElement = document.getElementById("root");
    rootElement.appendChild(createNewLoading);
    createNewLoading.appendChild(loadingGifImg);
    
    //join agora voice channel here also
    var el = document.getElementById("meetingButton");
    el.remove();
    
    var parkLogo = document.getElementById("parkLogo")
    parkLogo.remove();

    var signoutButton = document.getElementById("signoutButton")
    signoutButton.remove();


    if(userType === "admin"){
      var removeButton1 = document.getElementById("startAppointmentButton")
      removeButton1.remove();

      var removeButton2 = document.getElementById("createAppointmentButton");
      removeButton2.remove();
    }

    var furPlay = document.getElementById("callPlayer");
    furPlay.className = "overlay";
    //window.startChatByRoomID("testID");
    var idToUse = app.auth().currentUser.uid + "_" + USER_ID;

    this.joinChannel(userAppointmentCode, idToUse);

    this.UseAnotherAppointmentHome();
  }

  UseAnotherAppointmentHome = () =>{

    var d = new Date();
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var thisMonth = months[d.getMonth()];
    var thisYear = d.getFullYear();
    var yearString = thisYear.toString();

    app.database().ref('/kavtek_clients/' + project_code).once('value', snapshot => {

      if(snapshot.hasChild(yearString + thisMonth)){
        var totalAppUsed = snapshot.child(yearString + thisMonth).val();

        var totalAppsUsedRef = app.database().ref('/kavtek_clients/' + project_code + '/' + yearString + thisMonth);

        var newTotal = totalAppUsed + 1;

        totalAppsUsedRef.set(newTotal);

      }else{
        var totalAppsUsedRef = app.database().ref('/kavtek_clients/' + project_code + '/' + yearString + thisMonth);
        var totalAppUsed = 1;
        totalAppsUsedRef.set(totalAppUsed);
      }

    });
  }



  render(){
    // const handleJoinMeeting = () =>{
    //   CallFurioos();//then on user active then we pass informatioin
    //   //join agora voice channel here also
    //   var el = document.getElementById("meetingButton");
    //   el.remove();
      
    // }

    
    return (
      <>
        
        <div>
          <img className="BackBanner" src={backBanner} alt="Banner" />;
          <img id="parkLogo" className="parkLogo" src={logoParkvillegreens} alt="Logo" />;
          <button id="signoutButton" className="signOutButton" onClick={() => app.auth().signOut()}>Sign out</button>
        </div>
        
        <div className="BlackFrontOverlay" id="infoContainer">
            <h2 className="blackBoxTitle">Appointment</h2>
            <p className="GreenTitle">Host</p><p className="paragraphReg" id="yourHost"></p>
            <p className="GreenTitle">Your Name</p><p className="paragraphReg" id="yourName"></p>
            <p className="GreenTitle">Email</p><p className="paragraphReg" id="yourEmail"></p>
            <p className="GreenTitle">Phone Number</p><p className="paragraphReg" id="yourPhoneNumber"></p>
            <p className="GreenTitle">Appointment Time</p><p className="paragraphReg" id="yourAppointmentTime"></p>
          
          <button className="joinMeetingButton" id="meetingButton" >Join Meeting</button>
          <div id="callPlayer"></div>
          {Object.keys(this.state.remoteStreams).map(key => {
            let stream = this.state.remoteStreams[key];
            let streamId = stream.getId();
            // for (let value of Object.keys(this.state.remoteStreams)) {
            //   console.log("GOING THROUGH ALL REMOTE STREAM KEYS " + value);
            // }
            return (
              <div
                key={streamId}
                id={`agora_remote ${streamId}`}
                style={{ width: "0px", height: "0px" }}
              />
            );
          })}
        </div>
      </>
    );

  };
}

export default Home;
